interface RoutesMap {
  [route: string]: {
    name: string
    path: string
  }
}

export const routes: Readonly<RoutesMap> = Object.freeze({
  HOME: {
    name: 'Home',
    path: '/'
  },
  CALCULATIONS: {
    name: 'Calculations',
    path: '/calculations'
  },
  ABOUT: {
    name: 'About',
    path: '/about'
  },
  VIEW_CALCULATION: {
    name: 'View calculation',
    path: '/calculations/:calculationId'
  },
  VIEW_DOCUMENTATION: {
    name: 'View documentation',
    path: '/calculations/:calculationId/documentation'
  },
  UPLOAD_CSV: {
    name: 'Upload CSV',
    path: '/calculations/:calculationId/csv'
  }
})
